import {
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonContent,
  IonPage,
  IonGrid,
  IonCol,
  IonRow,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  useIonAlert,
  useIonLoading,
} from "@ionic/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { signInWithEmailAndPassword } from "@firebase/auth";
import { useHistory, useLocation } from "react-router-dom";
import { OverlayEventDetail } from "@ionic/core/components";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import "../theme/AppStyles.css";
import { NoConnectionMsg } from "../components/NoConnection";
import { isDesktop } from "../utils/platformUtils";

const Login: React.FC = () => {
    const [err1, setErr1] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const auth = getAuth();
    const [present] = useIonAlert();
    const modal = useRef<HTMLIonModalElement>(null);
    const input = useRef<HTMLIonInputElement>(null);
    const accountModal = useRef<HTMLIonModalElement>(null);
    const [showAccountModal, setShowAccountModal] = useState(false);
    const { networkConnection, usersID } = useContext(ProfileContext);
    
    // Extract returnUrl from query params
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl') || './Home';
    const showCancelButton = searchParams.has('returnUrl');
    
    // console.log("=== LOGIN COMPONENT DEBUG ===");
    // console.log("Location:", location.pathname + location.search);
    // console.log("Search params:", location.search);
    // console.log("returnUrl:", returnUrl);
    // console.log("showCancelButton:", showCancelButton);
    // console.log("usersID:", usersID);
    // console.log("auth.currentUser?.uid:", auth.currentUser?.uid);
    // console.log("=============================");

    const [presentLoading] = useIonLoading();
    useEffect(() => {
        // Only auto-redirect if BOTH auth.currentUser AND usersID are set,
        // AND the user is actually on the Login page. Without the pathname
        // guard, Ionic keeps Login mounted in the background and this effect
        // fires on any usersID change (e.g. after onboarding modals close),
        // causing spurious backwards navigation to CreateAccount.
        // presentLoading was also removed — its IonLoading overlay adds a
        // browser history entry that triggers history.go(-1) on auto-dismiss.
        if (auth.currentUser?.uid && usersID && location.pathname === '/login') {
            history.push(returnUrl);
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersID]);

    const signIn = async () => {
        if (auth.currentUser?.uid) {
            history.push(returnUrl);
        } else {
            setErr1(false);
            signInWithEmailAndPassword(auth, email, password)
                .then(() => {
                    // console.log('signed in');
                    history.push(returnUrl);
                })
                .catch((_error) => {
                    // console.log(error.code);
                    setErr1(true);
                    // console.log(error);
                });
        } 
    };

  const handleResetPassword = (emailToSend: string) => {
    // console.log("reset password, ", emailToSend);
    // console.log("projectId:", auth.app.options.projectId);
    // console.log("authDomain:", auth.app.options.authDomain);
    // console.log("email for reset:", emailToSend);
    sendPasswordResetEmail(auth, emailToSend)
      .then(() => {
        // console.log("Firebase accepted reset request");
        // password reset email sent!
        present({
          header: "Reset email has been sent. (May need to check spam folder.)",
          buttons: ["Ok"],
        });
      })
      .catch((_error) => {
        // console.log(error);
        // const errorCode = error.code;
        // const errorMessage = error.message;
        present({
          header: "Reset email was not sent.",
          buttons: ["Ok"],
        });
      });
  };

  function confirm() {
    modal.current?.dismiss(input.current?.value, "confirm");
  }

  function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
    if (ev.detail.role === "confirm") {
      // console.log(`${ev.detail.data}`);
      handleResetPassword(`${ev.detail.data}`);
    }
  }

  const LoginButtonLogin: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol>
            <IonButton
              onClick={signIn}
              color="warning"
              size="large"
              expand="block"
              fill="solid"
            >
              Login
            </IonButton>
          </IonCol>
        </IonRow>
      </React.Fragment>
    );
  };
  const LoginButtonCreateAcct: React.FC = () => {
    const handleCreateAccountClick = () => {
      if (isDesktop()) {
        setShowAccountModal(true);
      } else {
        history.push('/CreateAccount');
      }
    };

    return (
      <React.Fragment>
        <IonRow>
          <IonCol>
            <IonButton
              onClick={handleCreateAccountClick}
              color="medium"
              size="large"
              expand="block"
              fill="solid"
            >
              Create Account
            </IonButton>
          </IonCol>
        </IonRow>
      </React.Fragment>
    );
  };
  const LoginButtonForgotPW: React.FC = () => {
        return (
        <React.Fragment>
            <IonRow>
                <IonCol>
                    <IonButton id="open-modal" fill="clear" class="iontextwrap" >
                        Forgot Password?
                    </IonButton>
                    <IonModal ref={modal} trigger="open-modal" onWillDismiss={(ev) => onWillDismiss(ev)}>
                    <IonHeader>
                        <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={() => modal.current?.dismiss()}>Cancel</IonButton>
                        </IonButtons>
                        <IonTitle>Password Recovery</IonTitle>
                        <IonButtons slot="end">
                            <IonButton strong={true} onClick={() => confirm()}>
                            Submit
                            </IonButton>
                        </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">
                        <IonItem>
                        <IonLabel position="stacked">Enter your email</IonLabel>
                        <IonInput ref={input} type="text" placeholder="Your email" />
                        </IonItem>
                    </IonContent>
                    </IonModal>
                </IonCol>
            </IonRow>
            {err1 && <span>The password is incorrect</span>}
        </React.Fragment>
        );
    };
    
    const CancelButton: React.FC = () => {
        return (
        <React.Fragment>
            <IonRow>
                <IonCol>
                    <IonButton
                        onClick={() => history.push('/')}
                        color="light"
                        size="large"
                        expand="block"
                        fill="outline"
                    >
                        Cancel
                    </IonButton>
                </IonCol>
            </IonRow>
        </React.Fragment>
        );
    };

  // console.log(typeof networkConnection);
  return (
    <React.Fragment>
      <IonPage>
        {networkConnection === false && <NoConnectionMsg />}
        <IonContent>
          <div className="loginContainer">
            <span className="loginWrapper">
              <span className="logo">WerkApp</span>
              <span className="title">Login</span>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonItem
                    >
                      <IonInput
                        type="email"
                        name="Email"
                        placeholder="Email"
                        value={email}
                        onIonChange={(e: any) => setEmail(e.target.value)}
                        clearInput
                      ></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <IonItem
                    >
                      <IonInput
                        type="password"
                        name="Password"
                        placeholder="Password"
                        value={password}
                        onIonChange={(e: any) => setPassword(e.target.value)}
                        clearInput
                      ></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>

                <LoginButtonLogin />
                <LoginButtonCreateAcct />
                <LoginButtonForgotPW />
                {showCancelButton && <CancelButton />}
              </IonGrid>
            </span>
          </div>
        </IonContent>

        {/* Account Creation Modal for Desktop Users */}
        <IonModal 
          ref={accountModal} 
          isOpen={showAccountModal} 
          onDidDismiss={() => setShowAccountModal(false)}
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Account Creation</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowAccountModal(false)}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <h2>Download the app to create an account</h2>
              <p style={{ marginTop: '1rem', marginBottom: '2rem', color: '#666' }}>
                Account creation is only available through our mobile app.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '300px', margin: '0 auto' }}>
                <IonButton 
                  href="https://apps.apple.com/us/app/werkapp/id6446168426" 
                  target="_blank"
                  rel="noopener noreferrer"
                  expand="block"
                  color="dark"
                >
                  Download on App Store
                </IonButton>
                <IonButton 
                  href="https://play.google.com/store/apps/details?id=com.pipedream.werkapp&hl=en_US" 
                  target="_blank"
                  rel="noopener noreferrer"
                  expand="block"
                  color="success"
                >
                  Get it on Google Play
                </IonButton>
              </div>
            </div>
          </IonContent>
        </IonModal>
      </IonPage>
    </React.Fragment>
  );
};

export default Login;
